<template src="./perfil-da-loja.html"></template>
<style lang="less" src="./perfil-da-loja.less" scoped></style>

<script>
import BackgroundHeader from "@/components/headers/background-header/background-header";
import MenuCategoriasProduto from "@/modules/loja/menu/categorias/menu-categorias-produto";
import stringHelper from "@/helpers/string.helper";

import { mapState, mapGetters } from "vuex";
const PerfilDaLoja = "PerfilDaLoja";

export default {
  components: {
    BackgroundHeader,
    MenuCategoriasProduto,
  },
  data() {
    return {
      campoDeBusca: "",
      showCampoBusca: false,
      larguraAtualDaTela: window.innerWidth,
      paginaAtual: "",
      mostrarInfoLoja: false,
    };
  },
  created() {
    window.addEventListener("resize", this.ajustarTamanhoAtualDaTela);
    this.atualizarMostrarInfoLoja();
  },
  computed: {
    ...mapState(PerfilDaLoja, ["perfil"]),
    ...mapGetters(PerfilDaLoja, ["getNumeroCelularCompleto"]),
    callTo() {
      return `https://wa.me/${this.getNumeroCelularCompleto}`;
    },
    numeroCelularFormatado() {
      return stringHelper.FormatarNumeroDoCelular(
        this.perfil.numeroDoWhatsApp.toString()
      );
    },
    mailTo() {
      return `mailto:${this.perfil.email}`;
    },
    mobile() {
      return this.larguraAtualDaTela < 576;
    },
  },
  watch: {
    campoDeBusca() {
      this.digitouNoCampoDePesquisa();
    },
    $route() {
      this.atualizarMostrarInfoLoja();
    },
  },
  methods: {
    digitouNoCampoDePesquisa() {
      this.$emit("realizouPesquisaEvent", this.campoDeBusca);
    },
    alteraCssCampoImput() {
      this.showCampoBusca = !this.showCampoBusca;
    },
    irParaPaginaInicial() {
      if (window.location.pathname == "/") {
        this.campoDeBusca = "";
      } else this.$router.push({ name: "produto-listagem" });
    },
    ajustarTamanhoAtualDaTela(e) {
      this.larguraAtualDaTela = window.innerWidth;
    },
    changeSideBar() {
      this.$refs.sidebar.hide();
    },
    atualizarMostrarInfoLoja(){
      this.mostrarInfoLoja = this.$router.history.current.name === "produto-listagem";
    },
  },
};
</script>